import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M11.3 2.26c.45-.17.95-.17 1.4 0l6 2.25c.78.29 1.3 1.04 1.3 1.87v4.3c-.91-.43-1.92-.68-3-.68-3.87 0-7 3.13-7 7 0 1.95.8 3.71 2.08 4.98-.03 0-.05.01-.08.02-4.59-1.15-8-5.86-8-10.91v-4.7c0-.84.52-1.58 1.3-1.88zM17 12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm0 2c-.28 0-.5.22-.5.5v2h-2c-.28 0-.5.22-.5.5s.22.5.5.5h2v2c0 .28.22.5.5.5s.5-.22.5-.5v-2h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2v-2c0-.28-.22-.5-.5-.5z"
  }],
  circles: []
};
var AddModeratorIcon = function AddModeratorIcon(props) {
  return renderIcon(props, iconType);
};
export { AddModeratorIcon };